/* BLACKROLL — makes every "Celliant" / "CELLIANT®" text mention a link to the
   Celliant service page. Skips the Celliant page itself, existing links, form
   controls and script/style nodes. Idempotent.
   v3: prefilter is now case-insensitive (site content uses ALL-CAPS CELLIANT®,
   which the old indexOf('elliant') prefilter never matched); observer sits on
   documentElement because Horizon morphs #MainContent after first paint. */
(function () {
  'use strict';

  function href() {
    if (window.__brCelliantHref) return window.__brCelliantHref;
    var mm = location.pathname.match(/^\/(en|el)(\/|$)/);
    return (mm ? '/' + mm[1] : '') + '/pages/celliant';
  }
  if (location.pathname.indexOf('/pages/celliant') !== -1) return;

  var SKIP = {
    A: 1, SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, BUTTON: 1, TEMPLATE: 1,
    SELECT: 1, OPTION: 1, INPUT: 1, LABEL: 1, IFRAME: 1, svg: 1, TITLE: 1
  };
  var RE = /(CELLIANT|Celliant)(®)?/g;
  var PRE = /elliant/i;

  function skippable(el) {
    var p = el;
    while (p && p.nodeType === 1) {
      if (SKIP[p.tagName]) return true;
      if (p.classList && (p.classList.contains('br-celliant-link') || p.hasAttribute('data-no-celliant-link'))) return true;
      if (p.isContentEditable) return true;
      p = p.parentElement;
    }
    return false;
  }

  var busy = false;

  function linkify(node) {
    var text = node.nodeValue;
    RE.lastIndex = 0;
    if (!RE.test(text)) return;
    RE.lastIndex = 0;
    var frag = document.createDocumentFragment();
    var last = 0;
    var m;
    while ((m = RE.exec(text))) {
      if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
      var a = document.createElement('a');
      a.href = href();
      a.className = 'br-celliant-link';
      a.textContent = m[0];
      frag.appendChild(a);
      last = m.index + m[0].length;
    }
    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    node.parentNode.replaceChild(frag, node);
  }

  function initAll() {
    if (!document.body) return;
    busy = true;
    try {
      var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
      var nodes = [];
      var n;
      while ((n = walker.nextNode())) {
        if (n.nodeValue && PRE.test(n.nodeValue) && !skippable(n.parentElement)) nodes.push(n);
      }
      nodes.forEach(linkify);
    } finally {
      busy = false;
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  window.addEventListener('load', function () {
    initAll();
    setTimeout(initAll, 1000);
    setTimeout(initAll, 2500);
    setTimeout(initAll, 5000);
  });
  document.addEventListener('shopify:section:load', initAll);

  var scheduled = false;
  var mo = new MutationObserver(function () {
    if (busy || scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      if (busy) return;
      initAll();
    }, 120);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
